import * as actionTypes from "../types";
import { post, put } from "../../config/Requests";
import { deleteReq } from "../../config/Requests";
import { getToken } from "../../config/storageData";


export const addCar = (id, fetch) => {
  return dispatch => {
    post(
      dispatch,
      "kalendarz/lista_aut.php",
      {
        token: fetch.token,
        czas_od: fetch.startDate.startOf("day").unix(),
        czas_do: fetch.endDate.endOf("day").unix()
      },
      response => {
        dispatch(saveCars(response.data.data))
      }
    );
  };
};

export const updateCars = (id, data) => {
  return dispatch => {
    put(
      dispatch,
      `/kalendarz/drag_drop.php?id_wynajem=${id}`,
      data,
      (response) => {

        console.log("response", response);

        if (response && response.status === 200) {
          dispatch({type: actionTypes.OPEN_SNACKBAR, message: "Zmieniono wynajem"})
          dispatch({ type: actionTypes.SET_RENT, value: { rent: data, samochodId: data.samochod_id } })
          dispatch({ type: actionTypes.SET_POPOUT_DATA, value: { displayPopover: false } })
        } else {
          dispatch({type: actionTypes.OPEN_SNACKBAR, message: "Bład zmiany wynajmu", severity: "error" })
        }

      },
      (error) => {
        dispatch({type: actionTypes.OPEN_SNACKBAR, message: `Bład zmiany wynajmu: ${error} `, severity: "error" })
        dispatch({ type: actionTypes.SET_RENT, value: { id: id } })
      }
    );
  };
};

export const fetchCars = (token, startDate, endDate) => {
  return dispatch => {
    post(
      dispatch,
      "kalendarz/lista_aut.php",
      {
        token,
        czas_od: startDate.startOf("day").unix(),
        czas_do: endDate.endOf("day").unix()
      },
      response => dispatch(saveCars(response.data.data))
    );
  };
};

export const cancelRent = (data) => {
  return dispatch => put(
    dispatch,
    "kalendarz/usun_wynajem.php",
    data,
      () => {
      dispatch({type: actionTypes.OPEN_SNACKBAR, message: "Wynajem usunięty"})
    },
    () => {}
  );
}

export const clearCars = () => {
  return {
    type: actionTypes.CLEAR_CARS
  };
};

export const saveCars = cars => {
  return {
    type: actionTypes.FETCH_CARS,
    cars
  };
};

export const saveClients = clients => {
  return {
    type: actionTypes.FETCH_CLIENTS,
    clients
  };
};

export const updateClients = client => {
  return {
    type: actionTypes.UPDATE_CLIENTS,
    client
  };
};

export const fetchClients = token => {
  return dispatch => {
    post(dispatch, "kalendarz/lista_klienci.php", { token }, response => {
      dispatch(saveClients(response.data.klient));
    });
  };
};

export const deleteClient = id => {
  return dispatch => {
    let config = {
      data: { token: getToken() },
      params: { id: id }
    };
    deleteReq(
      dispatch,
      "kalendarz/usun_klient.php",
      config,
      () => {
        dispatch({
          type: actionTypes.DELETE_CLIENT,
          value: id
        });
      }
    )
  }
}

export const updateStartDate = date => {
  return {
    type: actionTypes.UPDATE_START_DATE,
    val: date
  };
};

export const fetchCarRentalList = (token, carId) => {
  return dispatch => {
    post(
        dispatch,
        "kalendarz/lista_wynajmow.php",
        {
          token,
          id_samochod: carId,
        },
        response => dispatch(getCarRentalList(response.data.data))
    );
  };
};

export const getCarRentalList = date => {
  return {
    type: actionTypes.GET_CAR_RENTAL_LIST,
    rentList: date
  };
};

export const clearCarRentalList = () => {
  return {
    type: actionTypes.CLEAR_CAR_RENTAL_LIST,
  };
};
